export default __webpack_public_path__ + "static/media/020-tea.ebff1c2e.svg";